import EmptyCard from "../../../../../../../atoms/EmptyCard";

export default function VisitTwo() {
  return (
    <>
      <h3> Visit 1 - Mar 10 </h3>
      <div className="empty_wrap">
        <EmptyCard
          imageHeight={240}
          title="Crew didn’t submit any report"
          description="The crew didn’t provide any work report for this visit."
          image="/images/empty-icons/no-archived.svg"
        />
      </div>
    </>
  );
}
